import Utils from '../../assets/js/Utils';

/* eslint-disable no-mixed-operators, camelcase */

const state = {
    agencyModal: false, // 同セッション内で代理店コード入力用のモーダルを表示したかどうかを保存しておく（同セッションでは2回以上表示させないため）
    agencyCode: '', // 代理店コード（同セッション内では使いまわすため保存しておく）
    agentCode: '', // 募集人コード（同セッション内では使いまわすため保存しておく）
    agencyMode: false, // 代理店かどうかで出し分けする箇所が各所にあるため保存。URLに?teian=1が付与されている場合は代理店（true）
    step2HelpMode: false, // step2で「ねんきん定期便がお手元にないかたはこちら」から先へ進んだときはtrueになる
    value1: '', // 年齢
    value1_text: '', // 年齢テキスト
    value2: '', // 性別
    value2_text: '', // 性別テキスト
    value3: '', // 職業区分（'自営業' or '会社員・公務員' or '専業主婦・専業主夫'）
    value3_text: '', // 職業区分テキスト（'自営業' or '会社員・公務員' or '専業主婦・専業主夫'）
    value4: '', // 加入の医療保険（'健康保険の被扶養者' or '国保の加入者'）
    value4_text: '', // 加入の医療保険テキスト（'健康保険の被扶養者' or '国民健康保険の加入者'）
    value5: '', // 配偶者の有無（0:なし, 1: あり）
    value5_text: '', // 配偶者の有無テキスト（'なし' or 'あり'）
    value6: '', // 配偶者の年齢
    value6_text: '', // 配偶者の年齢テキスト
    value7: '', // 18歳到達年度末日までのお子さまの人数
    value7_text: '', // 18歳到達年度末日までのお子さまの人数テキスト
    value8: '', // 厚生年金保険計（月数）
    value8_text: '', // 厚生年金保険計（月数）テキスト
    value9: '', // （1）国民年金 老齢基礎年金
    value9_text: '', // （1）国民年金 老齢基礎年金テキスト
    value10_1: '', // 一般厚生年金被保険者期間
    value10_1_text: '', // 一般厚生年金被保険者期間テキスト
    value10_2: '', // 公務員厚生年金被保険者期間
    value10_2_text: '', // 公務員厚生年金被保険者期間テキスト
    value10_3: '', // 私学共済厚生年金被保険者期間
    value10_3_text: '', // 私学共済厚生年金被保険者期間テキスト
    value11_1: '', // 老齢基礎年金
    value11_1_text: '', // 老齢基礎年金テキスト
    value11_2: '', // （1）と（2: 10_1 + 10_2 + 10_3）の合計
    value11_2_text: '', // （1）と（2: 10_1 + 10_2 + 10_3）の合計テキスト
    value12_1: '', // value12_12 まで、標準報酬月額（_2以降は代理店の時のみ使用）
    value12_1_text: '', // value12_1の文字列
    value12_2: '',
    value12_3: '',
    value12_4: '',
    value12_5: '',
    value12_6: '',
    value12_7: '',
    value12_8: '',
    value12_9: '',
    value12_10: '',
    value12_11: '',
    value12_12: '',
    value12_13: '', // value12_24 まで、健康保険の報酬月額（13を含め24まで代理店の時のみ使用）
    value12_13_text: '',
    value12_14: '',
    value12_15: '',
    value12_16: '',
    value12_17: '',
    value12_18: '',
    value12_19: '',
    value12_20: '',
    value12_21: '',
    value12_22: '',
    value12_23: '',
    value12_24: '',
    value12FirstHalfsShow: false, // 代理店モードにおける value12 シリーズ前半（標準報酬月額）の表示状態
    value12LastHalfsShow: false, // 代理店モードにおける value12 シリーズ後半（健康保険の報酬月額）の表示状態
    value13: '', // 現在から退職までの平均見込年収
    value13_text: '', // 現在から退職までの平均見込年収テキスト
    value14: '', // 退職予定年齢
    value14_text: '', // 退職予定年齢テキスト
    value15: '', // 世帯の年収
    value15_text: '', // 世帯の年収テキスト
    // 以下、MLC_OLI_NENKIN-68対応
    value16: '', // 過去、会社員・公務員であった期間の年数
    value17: '', // value16の期間のおおよその年収（賞与含む）
    value18: '', // 会社員・公務員の勤続年数
    value19: '', // value18の期間のおおよその年収（賞与含む）
    value20: '', // 60歳まで勤続した場合のおおよその年収（賞与含む）
    value21: '', // 毎月のおおよその月収（標準報酬月額）
    value22: '' // 直近のおおよその月収（標準報酬月額）
};

const getters = {
    agencyModal: (_state) => _state.agencyModal,
    agencyCode: (_state) => _state.agencyCode,
    agentCode: (_state) => _state.agentCode,
    agencyMode: (_state) => _state.agencyMode,
    step2HelpMode: (_state) => _state.step2HelpMode,
    value1: (_state) => _state.value1,
    value1_text: (_state) => _state.value1_text,
    value2: (_state) => _state.value2,
    value2_text: (_state) => _state.value2_text,
    value3: (_state) => _state.value3,
    value3_text: (_state) => _state.value3_text,
    value4: (_state) => _state.value4,
    value4_text: (_state) => _state.value4_text,
    value5: (_state) => _state.value5,
    value5_text: (_state) => _state.value5_text,
    value6: (_state) => _state.value6,
    value6_text: (_state) => _state.value6_text,
    value7: (_state) => _state.value7,
    value7_text: (_state) => _state.value7_text,
    value8: (_state) => _state.value8,
    value8_text: (_state) => _state.value8_text,
    value9: (_state) => _state.value9,
    value9_text: (_state) => _state.value9_text,
    value10_1: (_state) => _state.value10_1,
    value10_1_text: (_state) => _state.value10_1_text,
    value10_2: (_state) => _state.value10_2,
    value10_2_text: (_state) => _state.value10_2_text,
    value10_3: (_state) => _state.value10_3,
    value10_3_text: (_state) => _state.value10_3_text,
    value11_1: (_state) => _state.value11_1,
    value11_1_text: (_state) => _state.value11_1_text,
    value11_2: (_state) => _state.value11_2,
    value11_2_text: (_state) => _state.value11_2_text,
    value12_1: (_state) => _state.value12_1,
    value12_1_text: (_state) => _state.value12_1_text,
    value12_2: (_state) => _state.value12_2,
    value12_3: (_state) => _state.value12_3,
    value12_4: (_state) => _state.value12_4,
    value12_5: (_state) => _state.value12_5,
    value12_6: (_state) => _state.value12_6,
    value12_7: (_state) => _state.value12_7,
    value12_8: (_state) => _state.value12_8,
    value12_9: (_state) => _state.value12_9,
    value12_10: (_state) => _state.value12_10,
    value12_11: (_state) => _state.value12_11,
    value12_12: (_state) => _state.value12_12,
    value12_13: (_state) => _state.value12_13,
    value12_13_text: (_state) => _state.value12_13_text,
    value12_14: (_state) => _state.value12_14,
    value12_15: (_state) => _state.value12_15,
    value12_16: (_state) => _state.value12_16,
    value12_17: (_state) => _state.value12_17,
    value12_18: (_state) => _state.value12_18,
    value12_19: (_state) => _state.value12_19,
    value12_20: (_state) => _state.value12_20,
    value12_21: (_state) => _state.value12_21,
    value12_22: (_state) => _state.value12_22,
    value12_23: (_state) => _state.value12_23,
    value12_24: (_state) => _state.value12_24,
    value12FirstHalfsShow: (_state) => _state.value12FirstHalfsShow,
    value12LastHalfsShow: (_state) => _state.value12LastHalfsShow,
    value12FirstHalf: (_state) => [ // 標準報酬月額の配列（平均の値を使うため、空でないものだけを使用）
        _state.value12_1,
        _state.value12_2,
        _state.value12_3,
        _state.value12_4,
        _state.value12_5,
        _state.value12_6,
        _state.value12_7,
        _state.value12_8,
        _state.value12_9,
        _state.value12_10,
        _state.value12_11,
        _state.value12_12
    ].filter((val) => val !== ''),
    value12LastHalf: (_state) => [ // 健康保険の報酬月額の配列（平均の値を使うため、空でないものだけを使用）
        _state.value12_13,
        _state.value12_14,
        _state.value12_15,
        _state.value12_16,
        _state.value12_17,
        _state.value12_18,
        _state.value12_19,
        _state.value12_20,
        _state.value12_21,
        _state.value12_22,
        _state.value12_23,
        _state.value12_24
    ].filter((val) => val !== ''),
    value13: (_state) => _state.value13,
    value13_text: (_state) => _state.value13_text,
    value14: (_state) => _state.value14,
    value14_text: (_state) => _state.value14_text,
    value15: (_state) => _state.value15,
    value15_text: (_state) => _state.value15_text,
    value16: (_state) => _state.value16,
    value17: (_state) => _state.value17,
    value18: (_state) => _state.value18,
    value19: (_state) => _state.value19,
    value20: (_state) => _state.value20,
    value21: (_state) => _state.value21,
    value22: (_state) => _state.value22,
    // 「代理店コード」「募集人コード」バリデート
    validateCode: (_state) => {
        const valids = [];

        valids.push(
            typeof _state.agencyCode === 'string' && '' !== _state.agencyCode && 5 === _state.agencyCode.length
        );
        valids.push(
            typeof typeof _state.agentCode === 'string' && '' !== _state.agentCode && 7 <= _state.agentCode.length && _state.agentCode.length <= 8
        );

        return -1 === valids.indexOf(false);
    },
    // Step1 バリデート
    validateStep1: (_state) => {
        const valids = [];

        // 年齢チェック
        valids.push(
            typeof _state.value1 === 'number' && isFinite(_state.value1)
        );

        // 性別チェック
        valids.push(
            typeof _state.value2 === 'string' && _state.value2 !== ''
        );

        // 職業区分チェック
        valids.push(
            typeof _state.value3 === 'string' && _state.value3 !== ''
        );

        // 加入の公的医療保険チェック
        if (_state.value3 === '専業主婦・専業主夫') {
            valids.push(
                typeof _state.value4 === 'string' && _state.value4 !== ''
            );
        }

        // 配偶者の有無チェック（0:なし, 1: あり）
        valids.push(
            typeof _state.value5 === 'number' && isFinite(_state.value5)
        );

        // 配偶者の年齢チェック
        if (_state.value5 === 1) {
            valids.push(
                typeof _state.value6 === 'number' && isFinite(_state.value6)
            );
        }

        // 18歳到達年度末日までのお子さまの人数チェック
        valids.push(
            typeof _state.value7 === 'number' && isFinite(_state.value7)
        );

        // falseが一つでもあればinvalid（falseを返す）
        return -1 === valids.indexOf(false);
    },
    // Step2 バリデート
    validateStep2: (_state) => {
        const valids = [];

        if (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者') {
            valids.push(false);
        } else {
            // 厚生年金保険計（月数）のチェック
            if (!(_state.value3 === '自営業' || _state.value3 === '専業主婦・専業主夫')) {
                valids.push(
                    typeof _state.value8 === 'number' && isFinite(_state.value8) // TODO: && _state.value8 > 0
                );
            }

            // 標準報酬月額のチェック
            if (!(_state.value3 === '自営業' || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '国保の加入者') || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者'))) {
                valids.push(
                    typeof _state.value12_1 === 'number' && isFinite(_state.value12_1)
                );
            }

            if (_state.value1 < 50) { // 50歳未満
                // （1）国民年金 老齢基礎年金のチェック
                valids.push(
                    typeof _state.value9 === 'number' && isFinite(_state.value9)
                );
                // 一般厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_1 === 'number' && isFinite(_state.value10_1)) ||
                    (typeof _state.value10_1 === 'string' && _state.value10_1 === '')
                );
                // 公務員厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_2 === 'number' && isFinite(_state.value10_2)) ||
                    (typeof _state.value10_2 === 'string' && _state.value10_2 === '')
                );
                // 私学共済厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_3 === 'number' && isFinite(_state.value10_3)) ||
                    (typeof _state.value10_3 === 'string' && _state.value10_3 === '')
                );
            } else { // 50歳以上
                // 老齢基礎年金
                valids.push(
                    typeof _state.value11_1 === 'number' && isFinite(_state.value11_1)
                );
                // （1）と（2: 10_1 + 10_2 + 10_3）の合計
                valids.push(
                    typeof _state.value11_2 === 'number' && isFinite(_state.value11_2)
                );
            }
        }

        return -1 === valids.indexOf(false);
    },
    // Step2 バリデート（Step3 スキップ時）
    validateStep2SkipStep3: (_state) => {
        const valids = [];

        if (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者') {
            if (!(_state.value3 === '自営業' || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '国保の加入者') || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者'))) {
                valids.push(
                    typeof _state.value12_1 === 'number' && isFinite(_state.value12_1)
                );
            }

            if (_state.value1 < 50) { // 50歳未満
                // （1）国民年金 老齢基礎年金のチェック
                valids.push(
                    typeof _state.value9 === 'number' && isFinite(_state.value9)
                );
                // 一般厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_1 === 'number' && isFinite(_state.value10_1)) ||
                    (typeof _state.value10_1 === 'string' && _state.value10_1 === '')
                );
                // 公務員厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_2 === 'number' && isFinite(_state.value10_2)) ||
                    (typeof _state.value10_2 === 'string' && _state.value10_2 === '')
                );
                // 私学共済厚生年金被保険者期間
                valids.push(
                    (typeof _state.value10_3 === 'number' && isFinite(_state.value10_3)) ||
                    (typeof _state.value10_3 === 'string' && _state.value10_3 === '')
                );
            } else { // 50歳以上
                valids.push(
                    typeof _state.value11_1 === 'number' && isFinite(_state.value11_1)
                );
                valids.push(
                    typeof _state.value11_2 === 'number' && isFinite(_state.value11_2)
                );
            }
        } else {
            valids.push(false);
        }

        return -1 === valids.indexOf(false);
    },
    // Step2（代理店モード）バリデート
    validateStep2Agency: (_state) => {
        const valids = [];

        if (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者') {
            valids.push(false);
        } else {
            if (!(_state.value3 === '自営業' || _state.value3 === '専業主婦・専業主夫')) {
                valids.push(
                    typeof _state.value8 === 'number' && isFinite(_state.value8)
                );
            }

            if (!(_state.value3 === '自営業' || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '国保の加入者') || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者'))) {
                // 標準報酬月額のチェック。全てのセレクトボックスが表示されている場合は全てをチェック
                if (_state.value12FirstHalfsShow) {
                    const value12FirstHalfs = [
                        _state.value12_1,
                        _state.value12_2,
                        _state.value12_3,
                        _state.value12_4,
                        _state.value12_5,
                        _state.value12_6,
                        _state.value12_7,
                        _state.value12_8,
                        _state.value12_9,
                        _state.value12_10,
                        _state.value12_11,
                        _state.value12_12
                    ];
                    const value12LastHalfs = [
                        _state.value12_13,
                        _state.value12_14,
                        _state.value12_15,
                        _state.value12_16,
                        _state.value12_17,
                        _state.value12_18,
                        _state.value12_19,
                        _state.value12_20,
                        _state.value12_21,
                        _state.value12_22,
                        _state.value12_23,
                        _state.value12_24
                    ];
                    const value12FirstHalfsNumbers = value12FirstHalfs.filter(
                        (value) => typeof value === 'number' && isFinite(value)
                    );
                    const nvalue12FirstHalfsNumbers = value12FirstHalfsNumbers.length;
                    const value12LastHalfsNumbers = value12LastHalfs.filter(
                        (value) => typeof value === 'number' && isFinite(value)
                    );
                    const nvalue12LastHalfsNumbers = value12LastHalfsNumbers.length;

                    if (nvalue12LastHalfsNumbers <= 0) {
                        valids.push(
                            1 <= nvalue12FirstHalfsNumbers
                        );
                    } else {
                        valids.push(
                            1 <= nvalue12LastHalfsNumbers
                        );
                    }
                // 一つしか表示されていない場合は、一つだけチェック
                } else {
                    valids.push(
                        typeof _state.value12_1 === 'number' && isFinite(_state.value12_1)
                    );
                }
            }

            if (_state.value1 < 50) { // 50歳未満
                valids.push(
                    typeof _state.value9 === 'number' && isFinite(_state.value9)
                );
                valids.push(
                    (typeof _state.value10_1 === 'number' && isFinite(_state.value10_1)) ||
                    (typeof _state.value10_1 === 'string' && _state.value10_1 === '')
                );
                valids.push(
                    (typeof _state.value10_2 === 'number' && isFinite(_state.value10_2)) ||
                    (typeof _state.value10_2 === 'string' && _state.value10_2 === '')
                );
                valids.push(
                    (typeof _state.value10_3 === 'number' && isFinite(_state.value10_3)) ||
                    (typeof _state.value10_3 === 'string' && _state.value10_3 === '')
                );
            } else { // 50歳以上
                valids.push(
                    typeof _state.value11_1 === 'number' && isFinite(_state.value11_1)
                );
                valids.push(
                    typeof _state.value11_2 === 'number' && isFinite(_state.value11_2)
                );
            }
        }

        return -1 === valids.indexOf(false);
    },
    // Step2（代理店モード）バリデート（Step3 スキップ時）
    validateStep2AgencySkipStep3: (_state) => {
        const valids = [];

        if (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者') {
            if (!(_state.value3 === '自営業' || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '国保の加入者') || (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者'))) {
                if (_state.value12FirstHalfsShow) {
                    const value12FirstHalfs = [
                        _state.value12_1,
                        _state.value12_2,
                        _state.value12_3,
                        _state.value12_4,
                        _state.value12_5,
                        _state.value12_6,
                        _state.value12_7,
                        _state.value12_8,
                        _state.value12_9,
                        _state.value12_10,
                        _state.value12_11,
                        _state.value12_12
                    ];
                    const nvalue12FirstHalfs = value12FirstHalfs.length;
                    const value12LastHalfs = [
                        _state.value12_13,
                        _state.value12_14,
                        _state.value12_15,
                        _state.value12_16,
                        _state.value12_17,
                        _state.value12_18,
                        _state.value12_19,
                        _state.value12_20,
                        _state.value12_21,
                        _state.value12_22,
                        _state.value12_23,
                        _state.value12_24
                    ];
                    const nvalue12LastHalfs = value12LastHalfs.length;
                    const value12FirstHalfsNumbers = value12FirstHalfs.filter(
                        (value) => typeof value === 'number' && isFinite(value)
                    );
                    const nvalue12FirstHalfsNumbers = value12FirstHalfsNumbers.length;
                    const value12LastHalfsNumbers = value12LastHalfs.filter(
                        (value) => typeof value === 'number' && isFinite(value)
                    );
                    const nvalue12LastHalfsNumbers = value12LastHalfsNumbers.length;

                    if (nvalue12LastHalfsNumbers <= 0) {
                        valids.push(
                            nvalue12FirstHalfs === nvalue12FirstHalfsNumbers
                        );
                    } else {
                        valids.push(
                            nvalue12LastHalfs === nvalue12LastHalfsNumbers
                        );
                    }
                } else {
                    valids.push(
                        typeof _state.value12_1 === 'number' && isFinite(_state.value12_1)
                    );
                }
            }

            if (_state.value1 < 50) { // 50歳未満
                valids.push(
                    typeof _state.value9 === 'number' && isFinite(_state.value9)
                );
                valids.push(
                    (typeof _state.value10_1 === 'number' && isFinite(_state.value10_1)) ||
                    (typeof _state.value10_1 === 'string' && _state.value10_1 === '')
                );
                valids.push(
                    (typeof _state.value10_2 === 'number' && isFinite(_state.value10_2)) ||
                    (typeof _state.value10_2 === 'string' && _state.value10_2 === '')
                );
                valids.push(
                    (typeof _state.value10_3 === 'number' && isFinite(_state.value10_3)) ||
                    (typeof _state.value10_3 === 'string' && _state.value10_3 === '')
                );
            } else { // 50歳以上
                valids.push(
                    typeof _state.value11_1 === 'number' && isFinite(_state.value11_1)
                );
                valids.push(
                    typeof _state.value11_2 === 'number' && isFinite(_state.value11_2)
                );
            }
        } else {
            valids.push(false);
        }

        return -1 === valids.indexOf(false);
    },
    // Step2のヘルプのバリデート
    validateStep2Help: (_state) => {
        const valids = [];

        if (_state.value3 === '会社員・公務員') {
            valids.push(
                typeof _state.value18 === 'number' && isFinite(_state.value18)
            );
            if (_state.value1 < 50) {
                valids.push(
                    typeof _state.value19 === 'number' && isFinite(_state.value19)
                );
            } else {
                valids.push(
                    typeof _state.value20 === 'number' && isFinite(_state.value20)
                );
            }
            valids.push(
                typeof _state.value21 === 'number' && isFinite(_state.value21)
            );
        } else {
            valids.push(
                typeof _state.value16 === 'number' && isFinite(_state.value16)
            );
            valids.push(
                typeof _state.value17 === 'number' && isFinite(_state.value17)
            );
            if (_state.value3 === '専業主婦・専業主夫' && _state.value4 === '健康保険の被扶養者') {
                valids.push(
                    typeof _state.value22 === 'number' && isFinite(_state.value22)
                );
            }
        }

        return -1 === valids.indexOf(false);
    },
    // Step3 バリデート
    validateStep3: (_state) => {
        const valids = [];

        if (_state.value3 === '会社員・公務員') {
            // 現在から退職までの平均見込年収
            valids.push(
                typeof _state.value13 === 'number' && isFinite(_state.value13)
            );
            // 退職予定年齢
            valids.push(
                typeof _state.value14 === 'number' && isFinite(_state.value14)
            );
        }

        if (_state.value3 === '自営業' || _state.value3 === '専業主婦・専業主夫') {
            // 世帯の年収
            valids.push(
                typeof _state.value15 === 'string' && _state.value15 !== ''
            );
        }

        return -1 === valids.indexOf(false);
    },
    // 「健康保険の報酬月額」表示切替（代理店時のみ）
    toggleValue12Items: (_state) => {
        const value12s = [
            _state.value12_1,
            _state.value12_2,
            _state.value12_3,
            _state.value12_4,
            _state.value12_5,
            _state.value12_6,
            _state.value12_7,
            _state.value12_8,
            _state.value12_9,
            _state.value12_10,
            _state.value12_11,
            _state.value12_12
        ];
        let visible = false;

        // 620万円が選択されているものが一つでもある場合は、健康保険の報酬月額（直近の金額）を表示する
        if (0 <= value12s.indexOf(620000)) {
            visible = true;
        }

        return visible;
    },
    // value12 シリーズが入力されているか確認
    value12Inputed: (_state) => {
        const value12s = [
            _state.value12_1,
            _state.value12_2,
            _state.value12_3,
            _state.value12_4,
            _state.value12_5,
            _state.value12_6,
            _state.value12_7,
            _state.value12_8,
            _state.value12_9,
            _state.value12_10,
            _state.value12_11,
            _state.value12_12,
            _state.value12_13,
            _state.value12_14,
            _state.value12_15,
            _state.value12_16,
            _state.value12_17,
            _state.value12_18,
            _state.value12_19,
            _state.value12_20,
            _state.value12_21,
            _state.value12_22,
            _state.value12_23,
            _state.value12_24
        ];
        const inputedValue12s = value12s.filter((value) => {
            let result = false;

            if (typeof value === 'number' && isFinite(value)) {
                result = true;
            }

            return result;
        });

        return 1 <= inputedValue12s.length;
    },
    // 「ア.老齢厚生年金」の計算ロジック
    roureiKouseiNenkin: (_state) => {
        let value = 0;

        // MLC_OLI_NENKIN-67 ねんきん定期便未所持者対応
        if (_state.step2HelpMode) {
            let value16 = _state.value16;
            let value17 = _state.value17;
            let value18 = _state.value18;
            let value19 = _state.value19;

            if (!(typeof value16 === 'number' && isFinite(value16))) {
                value16 = 1;
            }
            if (!(typeof value17 === 'number' && isFinite(value17))) {
                value17 = 0;
            }
            if (!(typeof value18 === 'number' && isFinite(value18))) {
                value18 = 1;
            }
            if (!(typeof value19 === 'number' && isFinite(value19))) {
                value19 = 0;
            }

            if (_state.value3 === '会社員・公務員') {
                if (_state.value1 >= 50) {
                    value = Math.round(value19 * 5.481 / 1000 * (value18 + 60 - _state.value1) + 779300);
                } else {
                    value = Math.round(value19 * 5.481 / 1000 * value18);
                }
            } else {
                if (_state.value1 >= 50) {
                    value = Math.round(value17 * 5.481 / 1000 * value16) + 779300;
                } else {
                    value = Math.round(value17 * 5.481 / 1000 * value16);
                }
            }
        } else {
            let value10_1 = _state.value10_1;
            let value10_2 = _state.value10_2;
            let value10_3 = _state.value10_3;

            if (!(typeof value10_1 === 'number' && isFinite(value10_1))) {
                value10_1 = 0;
            }

            if (!(typeof value10_2 === 'number' && isFinite(value10_2))) {
                value10_2 = 0;
            }

            if (!(typeof value10_3 === 'number' && isFinite(value10_3))) {
                value10_3 = 0;
            }

            if (_state.value1 < 50) {
                value = value10_1 + value10_2 + value10_3;
            }
        }

        return value;
    },
    // 厚生年金保険 計（月数）
    kouseiNekinHokenTotalMonth: (_state) => {
        let kouseinekinhokenTotalMonth = _state.value8;

        // MLC_OLI_NENKIN-67 ねんきん定期便未所持者対応
        if (_state.step2HelpMode && _state.value3 === '会社員・公務員') {
            kouseinekinhokenTotalMonth = _state.value18 * 12;
        }

        return kouseinekinhokenTotalMonth;
    },
    kokuminNenkinRoureiKisoNenkin: (_state) => {
        let value = _state.value1 >= 50 ? _state.value11_1 : _state.value9;

        // MLC_OLI_NENKIN-67 ねんきん定期便未所持者対応
        if (_state.step2HelpMode) {
            // 50歳未満かどうかで式が変わる
            if (_state.value1 < 50) {
                value = Math.round(779300 * (_state.value1 - 20) / 40);
            } else {
                value = 779300;
            }
        }

        return value;
    },
    // 老齢厚生年金をカンマ付きで返す
    roureiKouseiNenkinString: (_state) => Utils.addComma(getters.roureiKouseiNenkin(_state)),
    // 「イ.平均見込み年収」をカンマ付きで返す
    heikinMikomiNenshuString: (_state) => Utils.addComma(_state.value13),
    // 「ウ.予定勤続年数」の計算
    yoteiKinzokuNensu: (_state) => {
        let result = 0;

        if (_state.value1 < 50 && _state.value3 === '会社員・公務員') {
            result = _state.value14 - _state.value1;
        }

        if (result < 0) {
            result = 0;
        }

        return result;
    },
    // 「エ.老齢厚生年金合計」の計算ロジック
    roureiKouseiNenkinTotal: (_state) => {
        let result = 0;

        if (_state.value1 < 50) { // 50歳未満
            const heikinMikomiNenshu = _state.value1 < 50 ? _state.value13 : 0;

            result = Math.round((getters.roureiKouseiNenkin(_state)) + heikinMikomiNenshu * (5.481 / 1000) * (getters.yoteiKinzokuNensu(_state)));
        } else { // 50歳以上
            if (_state.step2HelpMode) {
                if (_state.value3 === '会社員・公務員') {
                    if (_state.value1 >= 50) {
                        result = Math.round(_state.value20 * 5.481 / 1000 * (_state.value18 + 60 - _state.value1) + 779300) - getters.kokuminNenkinRoureiKisoNenkin(_state);
                    } else {
                        result = Math.round(_state.value20 * 5.481 / 1000 * _state.value18 + 779300) - getters.kokuminNenkinRoureiKisoNenkin(_state);
                    }
                } else {
                    result = Math.round(_state.value17 * 5.481 / 1000 * _state.value16 + 779300) - getters.kokuminNenkinRoureiKisoNenkin(_state);
                }
            } else {
                result = _state.value11_2 - _state.value11_1;
            }
        }

        return result;
    },
    // 老齢厚生年金合計（カンマつき）
    roureiKouseiNenkinTotalString: (_state) => {
        const result = getters.roureiKouseiNenkinTotal(_state);

        return Utils.addComma(result);
    },
    // 「オ.これまでの加入実績に応じた老齢基礎年金」
    koremadenoKanyuuJissekiNiOujitaNenkinGaku: (_state) => {
        let value = 0;

        if (_state.value1 < 50) {
            value = getters.kokuminNenkinRoureiKisoNenkin(_state);
        }

        return value;
    },
    // これまでの加入実績に応じた年金額（カンマつき）
    koremadenoKanyuuJissekiNiOujitaNenkinGakuString: (_state) => Utils.addComma(getters.koremadenoKanyuuJissekiNiOujitaNenkinGaku(_state)),
    // 「カ.現在から60歳までの年数」
    genzaiKara60SaiMadenoNensu: (_state) => {
        let year = 0;

        if (_state.value1 < 50) {
            year = 60 - _state.value1;
        }

        if (year < 0) {
            year = 0;
        }

        return year;
    },
    // 「キ.老齢基礎年金」の計算ロジック
    roureiKisoNenkin: (_state) => {
        let value = 0;

        // 50歳未満かどうかで式が変わる
        if (_state.value1 < 50) {
            value = getters.kokuminNenkinRoureiKisoNenkin(_state) + Math.round(779300 * (60 - _state.value1) / 40);
        } else {
            value = getters.kokuminNenkinRoureiKisoNenkin(_state);
        }

        // 上限値を設ける
        if (779300 <= value) {
            value = 779300;
        }

        return value;
    },
    roureiKisoNenkinString: (_state) => Utils.addComma(getters.roureiKisoNenkin(_state)),
    // 「ク.老齢年金合計」
    roureiNenkinTotal: (_state) => {
        let value = 0;

        // 50歳未満かどうかで式が変わる
        if (_state.value1 < 50) {
            value = getters.roureiKouseiNenkinTotal(_state) + getters.roureiKisoNenkin(_state);
        } else {
            if (_state.step2HelpMode) {
                if (_state.value3 === '会社員・公務員') {
                    if (_state.value1 >= 50) {
                        value = Math.round(_state.value20 * 5.481 / 1000 * (_state.value18 + 60 - _state.value1) + 779300);
                    } else {
                        value = Math.round(_state.value20 * 5.481 / 1000 * _state.value18 + 779300);
                    }
                } else {
                    value = Math.round(_state.value17 * 5.481 / 1000 * _state.value16 + 779300);
                }
            } else {
                value = _state.value11_2;
            }
        }

        return value;
    },
    roureiNenkinTotalString: (_state) => Utils.addComma(getters.roureiNenkinTotal(_state)),
    // 直近の標準報酬月額
    hyoujunHoushuGetugaku: (_state) => {
        let value = 0;

        if (_state.step2HelpMode) {
            if (_state.value3 === '専業主婦・専業主夫') {
                value = Number(_state.value22);
            } else if (_state.value3 === '会社員・公務員') {
                value = Number(_state.value21);
            }
        } else {
            if (getters.value12LastHalfsShow(_state)) {
                value = _state.value12_13;
            } else {
                value = _state.value12_1;
            }
        }

        return value;
    },
    // 「ケ.高額療養費」
    kougakuRyouyouValue: (_state) => {
        let value = 0;

        // 自営業、会社員・公務員、専業主婦・専業主夫により区分
        if (_state.value3 === '自営業') {
            // 世帯の年収により判定
            if (_state.value15 === '600万円超') {
                value = 0;
            } else if (_state.value15 === '210万円超～600万円以下') {
                value = 135140;
            } else if (_state.value15 === '210万円以下') {
                value = 184800;
            }
        } else if (_state.value3 === '会社員・公務員') {
            let hyoujunHoushuGetugaku = getters.hyoujunHoushuGetugaku(_state);

            // 平均報酬月額により判定
            if (hyoujunHoushuGetugaku >= 530000) {
                value = 0;
            } else if (hyoujunHoushuGetugaku < 530000 && hyoujunHoushuGetugaku >= 280000) {
                value = 135140;
            } else if (hyoujunHoushuGetugaku < 280000) {
                value = 184800;
            }
        } else if (_state.value3 === '専業主婦・専業主夫') {
            // 国民健康保険の加入者は世帯の年収で判定
            if (_state.value4 === '国保の加入者') {
                if (_state.value15 === '600万円超') {
                    value = 0;
                } else if (_state.value15 === '210万円超～600万円以下') {
                    value = 135140;
                } else if (_state.value15 === '210万円以下') {
                    value = 184800;
                }
                // 健康保険の場合は報酬月額により判定
            } else if (_state.value4 === '健康保険の被扶養者') {
                let hyoujunHoushuGetugaku = getters.hyoujunHoushuGetugaku(_state);

                if (typeof hyoujunHoushuGetugaku === 'number' && isFinite(hyoujunHoushuGetugaku)) {
                    if (hyoujunHoushuGetugaku >= 530000) {
                        value = 0;
                    } else if (hyoujunHoushuGetugaku < 530000 && hyoujunHoushuGetugaku >= 280000) {
                        value = 135140;
                    } else if (hyoujunHoushuGetugaku < 280000) {
                        value = 184800;
                    }
                } else {
                    value = 0;
                }
            }
        }

        return value;
    },
    kougakuRyouyouValueString: (_state) => {
        const kougakuRyouyouValue = getters.kougakuRyouyouValue(_state);
        let value = kougakuRyouyouValue;

        if (typeof kougakuRyouyouValue === 'number' && isFinite(kougakuRyouyouValue)) {
            value = Utils.addComma(kougakuRyouyouValue);
        }

        return value;
    },
    // 「コ.支給開始日以前12か月の各月の標準報酬月額を平均した額」
    hyoujunHoushuGetugakuHeikin: (_state) => {
        let i = 0;
        let sum = 0;
        let num = 0;
        let value = 0;

        if (_state.step2HelpMode) {
            value = Number(_state.value21);
        } else {
            if (_state.value3 === '会社員・公務員') {
                // 代理店の時、健康保険の報酬月額が表示されていればそちらを使う
                const values = getters.value12LastHalfsShow(_state) ? getters.value12LastHalf(_state) : getters.value12FirstHalf(_state);
                const len = values.length;

                for (; i < len; i++) {
                    sum += values[i];
                    num++;
                }

                if (num > 0) {
                    value = sum / num;
                }
            }
        }

        return value;
    },
    hyoujunHoushuGetugakuHeikinString: (_state) => Utils.addComma(getters.hyoujunHoushuGetugakuHeikin(_state)),
    // 「サ.傷病手当金」
    shoubyoTeate: (_state) => {
        let value = 0;

        if (_state.value3 === '会社員・公務員') {
            value = Math.round((Math.round(getters.hyoujunHoushuGetugakuHeikin(_state) / 30 * 0.1) * 10) * 2 / 3);
        }

        return value;
    },
    shoubyoTeateString: (_state) => Utils.addComma(getters.shoubyoTeate(_state)),
    // 「シ.現在までの平均年収」
    heikinNenshu: (_state) => {
        let value = 0;

        // 職業区分が会社員・公務員の場合のみ
        if (_state.value3 === '会社員・公務員') {
            // 女性、かつ18歳未満のお子さまの数が0のときは0
            if (_state.value2 === '女性' && _state.value7 === 0) {
                value = 0;
            } else {
                // 年齢によって区分
                if (_state.value1 < 50) {
                    value = Math.round(getters.roureiKouseiNenkin(_state) / getters.kouseiNekinHokenTotalMonth(_state) * 1000 / 5.481 * 12);
                } else {
                    value = Math.round(getters.roureiKouseiNenkinTotal(_state) / (getters.kouseiNekinHokenTotalMonth(_state) + (60 - _state.value1) * 12) * 1000 / 5.481 * 12);
                }
            }
        }

        return value;
    },
    heikinNenshuString: (_state) => Utils.addComma(getters.heikinNenshu(_state)),
    // 「ス.現在までの勤続年数（最低25年）」
    kinzokuNensu: (_state) => {
        let value = 0;

        // 職業区分が会社員・公務員の場合のみ
        if (_state.value3 === '会社員・公務員') {
            // 女性、かつ18歳未満のお子さまの数が0のときは0
            if (_state.value2 === '女性' && _state.value7 === 0) {
                value = 0;
            } else {
                value = Math.floor(getters.kouseiNekinHokenTotalMonth(_state) / 12);
                value = Math.max(value, 25); // 25未満の場合は25を返す
            }
        }

        return value;
    },
    // 「セ.中高齢寡婦加算」
    chuuKoureiKafuKasan: (_state) => {
        let value = 0;

        // 男性、会社員・公務員、配偶者あり、配偶者の年齢が40歳以上64歳以下、18最未満のお子様なしの場合のみ
        if (_state.value2 === '男性' && _state.value3 === '会社員・公務員' && _state.value5 === 1 && 40 <= _state.value6 && _state.value6 <= 64 && _state.value7 === 0) {
            value = 584500;
        }

        return value;
    },
    // 「ソ.遺族厚生年金合計」
    izokuKouseiNenkinTotal: (_state) => Math.round(getters.heikinNenshu(_state) * 5.481 / 1000 * getters.kinzokuNensu(_state) * 0.75 + getters.chuuKoureiKafuKasan(_state)),
    izokuKouseiNenkinTotalString: (_state) => Utils.addComma(getters.izokuKouseiNenkinTotal(_state)),
    // 「タ.遺族基礎年金合計」
    izokuKisoNenkinTotal: (_state) => {
        let value = 0;

        // 配偶者がいない場合
        if (_state.value5 === 0) {
            // 18最未満の子供の数で分岐
            if (_state.value7 === 1) {
                value = 779300;
            } else if (_state.value7 === 2) {
                value = 779300 + 224300;
            } else if (3 <= _state.value7) {
                value = 779300 + 224300 + 74800 * (_state.value7 - 2);
            }
        // 配偶者がいる場合
        } else {
            // 18最未満の子供の数で分岐
            if (_state.value7 > 0 && _state.value7 < 3) {
                value = 779300 + 224300 * _state.value7;
            } else if (_state.value7 >= 3) {
                value = 779300 + 224300 * 2 + 74800 * (_state.value7 - 2);
            }
        }

        return value;
    },
    izokuKisoNenkinTotalString: (_state) => Utils.addComma(getters.izokuKisoNenkinTotal(_state)),
    // 「チ.遺族年金合計」
    izokuNenkinTotal: (_state) => getters.izokuKouseiNenkinTotal(_state) + getters.izokuKisoNenkinTotal(_state),
    izokuNenkinTotalString: (_state) => Utils.addComma(getters.izokuNenkinTotal(_state))
};

// stateの値の変更は全てmutationを通します
const mutations = {
    CHANGE_AGENCY_MODAL(_state, _value) {
        _state.agencyModal = _value;
    },
    CHANGE_AGENCY_CODE(_state, _value) {
        _state.agencyCode = _value;
    },
    CHANGE_AGENT_CODE(_state, _value) {
        _state.agentCode = _value;
    },
    CHANGE_AGENCY_MODE(_state, _value) {
        _state.agencyMode = _value;
    },
    CHANGE_STEP2_HELP_MODE(_state, _value) {
        _state.step2HelpMode = _value;
    },
    CHANGE_VALUE1(_state, _value) {
        _state.value1 = _value;
    },
    CHANGE_VALUE1_TEXT(_state, _value) {
        _state.value1_text = _value;
    },
    CHANGE_VALUE2(_state, _value) {
        _state.value2 = _value;
    },
    CHANGE_VALUE2_TEXT(_state, _value) {
        _state.value2_text = _value;
    },
    CHANGE_VALUE3(_state, _value) {
        _state.value3 = _value;
    },
    CHANGE_VALUE3_TEXT(_state, _value) {
        _state.value3_text = _value;
    },
    CHANGE_VALUE4(_state, _value) {
        _state.value4 = _value;
    },
    CHANGE_VALUE4_TEXT(_state, _value) {
        _state.value4_text = _value;
    },
    CHANGE_VALUE5(_state, _value) {
        _state.value5 = _value;
    },
    CHANGE_VALUE5_TEXT(_state, _value) {
        _state.value5_text = _value;
    },
    CHANGE_VALUE6(_state, _value) {
        _state.value6 = _value;
    },
    CHANGE_VALUE6_TEXT(_state, _value) {
        _state.value6_text = _value;
    },
    CHANGE_VALUE7(_state, _value) {
        _state.value7 = _value;
    },
    CHANGE_VALUE7_TEXT(_state, _value) {
        _state.value7_text = _value;
    },
    CHANGE_VALUE8(_state, _value) {
        _state.value8 = _value;
    },
    CHANGE_VALUE8_TEXT(_state, _value) {
        _state.value8_text = _value;
    },
    CHANGE_VALUE9(_state, _value) {
        _state.value9 = _value;
    },
    CHANGE_VALUE9_TEXT(_state, _value) {
        _state.value9_text = _value;
    },
    CHANGE_VALUE10_1(_state, _value) {
        _state.value10_1 = _value;
    },
    CHANGE_VALUE10_1_TEXT(_state, _value) {
        _state.value10_1_text = _value;
    },
    CHANGE_VALUE10_2(_state, _value) {
        _state.value10_2 = _value;
    },
    CHANGE_VALUE10_2_TEXT(_state, _value) {
        _state.value10_2_text = _value;
    },
    CHANGE_VALUE10_3(_state, _value) {
        _state.value10_3 = _value;
    },
    CHANGE_VALUE10_3_TEXT(_state, _value) {
        _state.value10_3_text = _value;
    },
    CHANGE_VALUE11_1(_state, _value) {
        _state.value11_1 = _value;
    },
    CHANGE_VALUE11_1_TEXT(_state, _value) {
        _state.value11_1_text = _value;
    },
    CHANGE_VALUE11_2(_state, _value) {
        _state.value11_2 = _value;
    },
    CHANGE_VALUE11_2_TEXT(_state, _value) {
        _state.value11_2_text = _value;
    },
    CHANGE_VALUE12_1(_state, _value) {
        _state.value12_1 = _value;
    },
    CHANGE_VALUE12_1_TEXT(_state, _value) {
        _state.value12_1_text = _value;
    },
    CHANGE_VALUE12_2(_state, _value) {
        _state.value12_2 = _value;
    },
    CHANGE_VALUE12_3(_state, _value) {
        _state.value12_3 = _value;
    },
    CHANGE_VALUE12_4(_state, _value) {
        _state.value12_4 = _value;
    },
    CHANGE_VALUE12_5(_state, _value) {
        _state.value12_5 = _value;
    },
    CHANGE_VALUE12_6(_state, _value) {
        _state.value12_6 = _value;
    },
    CHANGE_VALUE12_7(_state, _value) {
        _state.value12_7 = _value;
    },
    CHANGE_VALUE12_8(_state, _value) {
        _state.value12_8 = _value;
    },
    CHANGE_VALUE12_9(_state, _value) {
        _state.value12_9 = _value;
    },
    CHANGE_VALUE12_10(_state, _value) {
        _state.value12_10 = _value;
    },
    CHANGE_VALUE12_11(_state, _value) {
        _state.value12_11 = _value;
    },
    CHANGE_VALUE12_12(_state, _value) {
        _state.value12_12 = _value;
    },
    CHANGE_VALUE12_13(_state, _value) {
        _state.value12_13 = _value;
    },
    CHANGE_VALUE12_13_TEXT(_state, _value) {
        _state.value12_13_text = _value;
    },
    CHANGE_VALUE12_14(_state, _value) {
        _state.value12_14 = _value;
    },
    CHANGE_VALUE12_15(_state, _value) {
        _state.value12_15 = _value;
    },
    CHANGE_VALUE12_16(_state, _value) {
        _state.value12_16 = _value;
    },
    CHANGE_VALUE12_17(_state, _value) {
        _state.value12_17 = _value;
    },
    CHANGE_VALUE12_18(_state, _value) {
        _state.value12_18 = _value;
    },
    CHANGE_VALUE12_19(_state, _value) {
        _state.value12_19 = _value;
    },
    CHANGE_VALUE12_20(_state, _value) {
        _state.value12_20 = _value;
    },
    CHANGE_VALUE12_21(_state, _value) {
        _state.value12_21 = _value;
    },
    CHANGE_VALUE12_22(_state, _value) {
        _state.value12_22 = _value;
    },
    CHANGE_VALUE12_23(_state, _value) {
        _state.value12_23 = _value;
    },
    CHANGE_VALUE12_24(_state, _value) {
        _state.value12_24 = _value;
    },
    CHANGE_VALUE12_FIRST_HALFS_SHOW(_state, _value) {
        _state.value12FirstHalfsShow = _value;
    },
    CHANGE_VALUE12_LAST_HALFS_SHOW(_state, _value) {
        _state.value12LastHalfsShow = _value;
    },
    CHANGE_VALUE13(_state, _value) {
        _state.value13 = _value;
    },
    CHANGE_VALUE13_TEXT(_state, _value) {
        _state.value13_text = _value;
    },
    CHANGE_VALUE14(_state, _value) {
        _state.value14 = _value;
    },
    CHANGE_VALUE14_TEXT(_state, _value) {
        _state.value14_text = _value;
    },
    CHANGE_VALUE15(_state, _value) {
        _state.value15 = _value;
    },
    CHANGE_VALUE15_TEXT(_state, _value) {
        _state.value15_text = _value;
    },
    CHANGE_VALUE16(_state, _value) {
        _state.value16 = _value;
    },
    CHANGE_VALUE17(_state, _value) {
        _state.value17 = _value;
    },
    CHANGE_VALUE18(_state, _value) {
        _state.value18 = _value;
    },
    CHANGE_VALUE19(_state, _value) {
        _state.value19 = _value;
    },
    CHANGE_VALUE20(_state, _value) {
        _state.value20 = _value;
    },
    CHANGE_VALUE21(_state, _value) {
        _state.value21 = _value;
    },
    CHANGE_VALUE22(_state, _value) {
        _state.value22 = _value;
    }
};

// .vueからはactionsを通して実行されます
const actions = {
    changeAgencyModal({commit}, _value) {
        let modal = _value;

        if (typeof modal !== 'boolean') {
            modal = false;
        }

        commit('CHANGE_AGENCY_MODAL', modal);
    },
    changeAgencyCode({commit}, _value) {
        const code = Utils.convertFullWidthStringToHalfWidthString(_value);

        commit('CHANGE_AGENCY_CODE', code);
    },
    changeAgentCode({commit}, _value) {
        const code = Utils.convertFullWidthStringToHalfWidthString(_value);

        commit('CHANGE_AGENT_CODE', code);
    },
    changeAgencyMode({commit}, _value) {
        let mode = _value;

        if (typeof mode !== 'boolean') {
            mode = false;
        }

        commit('CHANGE_AGENCY_MODE', mode);
    },
    changeStep2HelpMode({commit}, _value) {
        let mode = _value;

        if (typeof mode !== 'boolean') {
            mode = false;
        }

        commit('CHANGE_STEP2_HELP_MODE', mode);
    },
    changeValue1({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 16) {
            number = 16;
        } else if (59 < number) {
            number = 59;
        }

        commit('CHANGE_VALUE1', number);
    },
    changeValue1Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE1_TEXT', value);
    },
    changeValue2({commit}, _value) {
        commit('CHANGE_VALUE2', _value);
    },
    changeValue2Text({commit}, _value) {
        commit('CHANGE_VALUE2_TEXT', _value);
    },
    changeValue3({commit}, _value) {
        commit('CHANGE_VALUE3', _value);
    },
    changeValue3Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE3_TEXT', value);
    },
    changeValue4({commit}, _value) {
        commit('CHANGE_VALUE4', _value);
    },
    changeValue4Text({commit}, _value) {
        commit('CHANGE_VALUE4_TEXT', _value);
    },
    changeValue5({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else if (1 < number) {
            number = 1;
        }

        commit('CHANGE_VALUE5', number);
    },
    changeValue5Text({commit}, _value) {
        commit('CHANGE_VALUE5_TEXT', _value);
    },
    changeValue6({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 16) {
            number = 16;
        } else if (69 < number) {
            number = 69;
        }

        commit('CHANGE_VALUE6', number);
    },
    changeValue6Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE6_TEXT', value);
    },
    changeValue7({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else if (5 < number) {
            number = 5;
        }

        commit('CHANGE_VALUE7', number);
    },
    changeValue7Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE7_TEXT', value);
    },
    changeValue8({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE8', number);
    },
    changeValue8Text({commit}, _value) {
        commit('CHANGE_VALUE8_TEXT', _value);
    },
    changeValue9({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        // 上限値を設ける
        } else if (779300 < number) {
            number = 779300;
        }

        commit('CHANGE_VALUE9', number);
    },
    changeValue9Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE9_TEXT', value);
    },
    changeValue10_1({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE10_1', number);
    },
    changeValue10_1Text({commit}, _value) {
        commit('CHANGE_VALUE10_1_TEXT', _value);
    },
    changeValue10_2({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE10_2', number);
    },
    changeValue10_2Text({commit}, _value) {
        commit('CHANGE_VALUE10_2_TEXT', _value);
    },
    changeValue10_3({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE10_3', number);
    },
    changeValue10_3Text({commit}, _value) {
        commit('CHANGE_VALUE10_3_TEXT', _value);
    },
    changeValue11_1({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        // 上限値を設ける
        } else if (779300 < number) {
            number = 779300;
        }

        commit('CHANGE_VALUE11_1', number);
    },
    changeValue11_1Text({commit}, _value) {
        commit('CHANGE_VALUE11_1_TEXT', _value);
    },
    changeValue11_2({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE11_2', number);
    },
    changeValue11_2Text({commit}, _value) {
        commit('CHANGE_VALUE11_2_TEXT', _value);
    },
    changeValue12_1({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_1', number);
    },
    changeValue12_1Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE12_1_TEXT', value);
    },
    changeValue12_2({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_2', number);
    },
    changeValue12_3({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_3', number);
    },
    changeValue12_4({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_4', number);
    },
    changeValue12_5({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_5', number);
    },
    changeValue12_6({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_6', number);
    },
    changeValue12_7({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_7', number);
    },
    changeValue12_8({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_8', number);
    },
    changeValue12_9({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_9', number);
    },
    changeValue12_10({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_10', number);
    },
    changeValue12_11({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_11', number);
    },
    changeValue12_12({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_12', number);
    },
    changeValue12_13({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_13', number);
    },
    changeValue12_13Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE12_13_TEXT', value);
    },
    changeValue12_14({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_14', number);
    },
    changeValue12_15({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_15', number);
    },
    changeValue12_16({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_16', number);
    },
    changeValue12_17({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_17', number);
    },
    changeValue12_18({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_18', number);
    },
    changeValue12_19({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_19', number);
    },
    changeValue12_20({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_20', number);
    },
    changeValue12_21({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_21', number);
    },
    changeValue12_22({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_22', number);
    },
    changeValue12_23({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_23', number);
    },
    changeValue12_24({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE12_24', number);
    },
    changeValue12FirstHalfsShow({commit}, _value) {
        let visible = _value;

        if (typeof visible !== 'boolean') {
            visible = false;
        }

        commit('CHANGE_VALUE12_FIRST_HALFS_SHOW', visible);
    },
    changeValue12LastHalfsShow({commit}, _value) {
        let visible = _value;

        if (typeof visible !== 'boolean') {
            visible = false;
        }

        commit('CHANGE_VALUE12_LAST_HALFS_SHOW', visible);
    },
    changeValue13({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 単位が万円のため
            number *= 10000;

            // 上限値を設ける
            if (11940000 <= number) {
                number = 11940000;
            }
        }

        commit('CHANGE_VALUE13', number);
    },
    changeValue13Text({commit}, _value) {
        commit('CHANGE_VALUE13_TEXT', _value);
    },
    changeValue14({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE14', number);
    },
    changeValue14Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE14_TEXT', value);
    },
    changeValue15({commit}, _value) {
        commit('CHANGE_VALUE15', _value);
    },
    changeValue15Text({commit}, _value) {
        let value = _value;

        if (value === '選択ください') {
            value = '';
        }

        commit('CHANGE_VALUE15_TEXT', value);
    },
    // 過去、会社員・公務員であった期間の年数
    changeValue16({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 上限値を設ける
            if (54 <= number) {
                number = 54;
            }
        }

        commit('CHANGE_VALUE16', number);
    },
    // 過去、会社員・公務員であった期間のおおよその年収（賞与含む）
    changeValue17({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 単位が万円のため
            number *= 10000;

            // 上限値を設ける
            if (11940000 <= number) {
                number = 11940000;
            }
        }

        commit('CHANGE_VALUE17', number);
    },
    // 会社員・公務員の勤続年数
    changeValue18({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 上限値を設ける
            if (54 <= number) {
                number = 54;
            }
        }

        commit('CHANGE_VALUE18', number);
    },
    // 会社員・公務員の期間のおおよその年収（賞与含む）
    changeValue19({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 単位が万円のため
            number *= 10000;

            // 上限値を設ける
            if (11940000 <= number) {
                number = 11940000;
            }
        }

        commit('CHANGE_VALUE19', number);
    },
    // 60歳まで勤続した場合のおおよその年収（賞与含む）
    changeValue20({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        } else {
            // 単位が万円のため
            number *= 10000;

            // 上限値を設ける
            if (11940000 <= number) {
                number = 11940000;
            }
        }

        commit('CHANGE_VALUE20', number);
    },
    // 毎月のおおよその月収（標準報酬月額）
    changeValue21({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE21', number);
    },
    // （配偶者の）直近のおおよその月収（標準報酬月額）
    changeValue22({commit}, _value) {
        let number = Utils.convertStringToNumber(_value);

        if (typeof number !== 'number' || !isFinite(number)) {
            number = '';
        } else if (number < 0) {
            number = 0;
        }

        commit('CHANGE_VALUE22', number);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/Simulator.js